export const EMPTY_SHILS = '___-___-_____';
